'use client';

import Link from 'next/link';
import { ComponentType, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import theme from '@/theme';

export type SportsClientLinkProps = {
  url: string;
  icon?: ComponentType;
  iconMobile?: ComponentType;
  ariaLabel?: string;
  target?: string;
  isMobileDevice?: boolean;
  locale?: string;
};

export const SportsClientLink = ({
  icon: Icon,
  iconMobile: IconMobile,
  url,
  ariaLabel,
  target,
  isMobileDevice,
  locale,
}: SportsClientLinkProps) => {
  const { t } = useTranslation();

  const name = t('menu.sports');

  const arrowElement = useMemo(() => {
    if (!isMobileDevice) return null;

    return (
      <div className="arrow">
        <theme.images.arrowUpGrayIcon.component />
      </div>
    );
  }, [isMobileDevice]);

  return (
    <>
      <Link
        href={url}
        target={target}
        className={locale?.toLowerCase()}
        aria-label={ariaLabel || name}
      >
        {isMobileDevice ? IconMobile && <IconMobile /> : Icon && <Icon />}
        {name}
      </Link>
      {arrowElement}
    </>
  );
};
